
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import image1 from "../img/tradly/image-10-1024x292.png"
import image2 from "../img/tradly/image-11-1024x361.png"
import image3 from "../img/tradly/image-8-563x1024.png"
import image4 from "../img/tradly/image-12-1024x294.png"
import image5 from "../img/tradly/image-9.png"
import image6 from "../img/tradly/crowdfunding-campaign-1024x502.png"
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Building a crowdfunding platforms like Kickstarter, Indiegogo & Gofundme",
  "date": "2019-10-03"
};
const slug = 'building-an-crowdfunding-platforms';
const tableOfContents = [{
  "title": "Configure Multiple Categories",
  "slug": "configure-multiple-categories",
  "children": []
}, {
  "title": "Custom Collections of crowdfunding campaigns",
  "slug": "custom-collections-of-crowdfunding-campaigns",
  "children": []
}, {
  "title": "Extensive fields available on API as well pre-built into apps",
  "slug": "extensive-fields-available-on-api-as-well-pre-built-into-apps",
  "children": []
}, {
  "title": "Further Readings",
  "slug": "further-readings",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Platform business model on funding has really disrupted the status quo. Thanks to crowdfunding platforms like Kickstarter, Indiegogo & Gofundme. They made the mass audience believe this model will work out whether you want to fund a creator or helping a cause. According to Giving USA 2019, a study of charitable giving in the United States, $300 Billion was given by individuals to a charity organization.`}</p>
    <p>{`Crowdfunding breaks the monopoly domination of funding and lending, it democratised the common man to invest/raise through campaign posting. What Kickstarter and Gofundme have disrupted can be applied in many industries as well.`}</p>
    <p>{`If you are one, looking into entering into different niches or markets, here is how TradlyPlatform can help you to build and launch your `}<a parentName="p" {...{
        "href": "https://tradly.app/build-marketplace-native-apps-without-coding/"
      }}>{`crowdfunding platforms without writing code`}</a>{` and versatile features.`}</p>
    <p>{`Here are the building blocks of building a crowdfunding platform.`}</p>
    <_Heading level={2} id={"configure-multiple-categories"} nextElement={{
      "type": "paragraph"
    }}>Configure Multiple Categories</_Heading>
    <p>{`You can configure single top-level categories or tree with 3-4 layers for your end-users to browse through the campaign. Kickstarter has a single level of categories but Indiegogo has multiple levels of categories`}</p>
    <img src={image1} alt=" " />
    <p>{`Indiegogo categories`}</p>
    <img src={image2} alt=" " />
    <p>{`Indiegogo categories`}</p>
    <img src={image3} alt=" " />
    <p>{`Kickstarter Categories`}</p>
    <_Heading level={2} id={"custom-collections-of-crowdfunding-campaigns"} nextElement={{
      "type": "paragraph"
    }}>Custom Collections of crowdfunding campaigns</_Heading>
    <p>{`You can create collections of account profiles or campaign collections on our SuperAdmin Panel with multiple combinations. There is no limit on the number of collections you can have in your app or website.`}</p>
    <img src={image4} alt=" " />
    <p>{`Indiegogo custom collection of campaigns`}</p>
    <img src={image5} alt=" " />
    <p>{`Kickstarter Collections`}</p>
    <_Heading level={2} id={"extensive-fields-available-on-api-as-well-pre-built-into-apps"} nextElement={{
      "type": "paragraph"
    }}>Extensive fields available on API as well pre-built into apps</_Heading>
    <p>{`All the highlighted fields are already available for you to activate or deactivate based on your needs.`}</p>
    <img src={image6} alt=" " />
    <p>{`We have all these fields here as API endpoints to use or in pre-built apps.`}</p>
    <p><strong parentName="p">{`This is just a glimpse of the features block example.`}</strong>{` TradlyPlatform API and Native Apps have versatile features available for you to build and launch your crowdfunding platforms. `}<a parentName="p" {...{
        "href": "https://tradly.app/signup"
      }}>{`Signup for the FREE ACCOUNT`}</a>{` and check out. or contact us directly to set up things for you!`}</p>
    <_Heading level={2} id={"further-readings"} nextElement={{
      "type": "export"
    }}>Further Readings</_Heading>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
